import React from 'react';
import './registration-order-summary-line-item.scss';
import { defaultLayouts, defaultTypography } from 'golfstatus_react_components';
const RegistrationOrderSummaryLineItem = ({item}) => {
  const paymentLabelStyle = () => {
    if (item?.value === "Select a Payment Method to Calculate Fees" || item?.value === "Fees Calculated at Payment") {
      return {...defaultTypography.bodyRegular.withOpacity(.5)}
    }
    else {
      return {...defaultTypography.bodyRegular}
    }
  }
  return (
    <registration-order-summary-line-item>
      <div style={{...defaultTypography.bodyRegular.withOpacity(.7), ...defaultTypography.uppercase, ...defaultTypography.overline2, ...defaultLayouts.vStack.align("center", "center")}} className="label">{item.label}</div>
      <div style={paymentLabelStyle()} className="value">{item.value}</div>
    </registration-order-summary-line-item>
  );
}

export default RegistrationOrderSummaryLineItem;
